export * from './auth-header';
export * from './fetchData';
export * from './language';
const doParseTime = function(data){
    var dt = new Date(data*1000);
    return dt.toLocaleString();
};

export {doParseTime};